import React from 'react';
import {Modal, Button, Col, Input, Form, Row, DatePicker, Select, Checkbox} from 'antd';

const FormItem = Form.Item;
const Option = Select.Option;

class AccountPageModal extends React.Component {
    state = {
        visible: false,
        form: {
            startDate: '',
            nickName: '',
            portfolioNumber: '',
            IBFilePrefix: ''
        },
    }
  
    onSubmit = () => {
    
    }

    render() {

        const { getFieldDecorator } = this.props.form
        const { form, } = this.state
        return (

            <Modal
                title="Add Account"
                visible={this.props.visible}
                onCancel={this.props.hideAccountModal}
                footer={[
                    <Button key="submit" type="primary" onClick={this.onSubmit}>Save</Button>,
                    <Button key="back" onClick={this.props.hideAccountModal}>Cancel</Button>,
                ]}>
                <Form onSubmit={this.handleSubmit}>
                    <Row gutter={16}>
                        <Col span={12}>
                            <FormItem label="Start Date:">
                                {getFieldDecorator('startDate:', {
                                    initialValue: form.startDate,
                                    rules: [
                                        {
                                            required: true, message: 'Please input date!',
                                        }
                                    ]
                                })(<DatePicker style={{width: 225}}/>)}
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem label="Account Status">
                                <Select defaultValue="lucy" style={{width: 225}}>
                                    <Option value="jack">Jack</Option>
                                    <Option value="lucy">Lucy</Option>
                                    <Option value="disabled">Disabled</Option>
                                    <Option value="Yiminghe">yiminghe</Option>
                                </Select>
                            </FormItem>
                        </Col>
                    </Row>

                    <FormItem label="Portfolio Nickname">
                        {getFieldDecorator('nickName', {
                            initialValue: form.nickName,
                            rules: [
                                {
                                    required: true, message: 'Please input Nickname!',
                                }
                            ]
                        })(<Input/>)}
                    </FormItem>

                    <FormItem label="Portfolio Number">
                        {getFieldDecorator('portfolioNumber', {
                            initialValue: form.portfolioNumber,
                            rules: [
                                {
                                    required: true, message: 'Please input subject!',
                                }
                            ]
                        })(<Input/>)}
                    </FormItem>
                    <Row gutter={16}>
                        <Col span={12}>
                            <FormItem label="Brokerage:">
                                <Select defaultValue="lucy" style={{width: 225}}>
                                    <Option value="jack">Jack</Option>
                                    <Option value="lucy">Lucy</Option>
                                    <Option value="disabled">Disabled</Option>
                                    <Option value="Yiminghe">yiminghe</Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem label="Risk Tolerance:">
                                <Select defaultValue="lucy" style={{width: 225}}>
                                    <Option value="jack">Jack</Option>
                                    <Option value="lucy">Lucy</Option>
                                    <Option value="disabled">Disabled</Option>
                                    <Option value="Yiminghe">yiminghe</Option>
                                </Select>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={12}>
                            <FormItem>
                                {getFieldDecorator('isTaxable', {
                                    valuePropName: 'checked',
                                    defaultValue: false,
                                })(
                                    <Checkbox>Taxable</Checkbox>
                                )}
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem>
                                {getFieldDecorator('isDiscretionary', {
                                    valuePropName: 'checked',
                                    defaultValue: false,
                                })(
                                    <Checkbox>Discretionary</Checkbox>
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        );
    }
}

const AccountModal = Form.create()(AccountPageModal)
export default AccountModal


// WEBPACK FOOTER //
// ./src/components/setup-and-settings/accountModal.js